export { default as Layout } from './BaseLayout'
export { default as SeekerLayout } from './SeekerLayout'
export { default as EmployerLayout } from './EmployerLayout'
export { default as OrgLayout } from './OrgLayout'
export { default as TutorialLayout } from './TutorialLayout'
export { default as ResumeLayout } from './ResumeLayout'
export { default as AdminLayout } from './AdminLayout'
